import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import { CartProvider } from "./contexts/CartContext";
import CartDrawer from "./components/feature/CartDrawer";
import ScrollToTop from "./components/base/ScrollToTop";

function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <BrowserRouter basename={__BASE_PATH__}>
        <CartProvider>
          <ScrollToTop />
          <AppRoutes />
          <CartDrawer />
        </CartProvider>
      </BrowserRouter>
    </I18nextProvider>
  );
}

export default App;